export enum LocationSubset {
  'All',
  'Assigned',
  'Spare',
  'Swapped',
  'Housekeeping',
  'Staff',
  'FrontDesk',
  'Bar',
  'Kiosk',
}
